import React from "react";
import DialogActions from "@material-ui/core/DialogActions/";
import DialogContent from "@material-ui/core/DialogContent/";
import DialogContentText from "@material-ui/core/DialogContentText/";
import DialogTitle from "@material-ui/core/DialogTitle/";
import { Button, StyledDialog } from "./components/Dialog/style";
import { InputField } from "../../components/Input";

export default function ConfirmChangeStatusDialog({
	open,
	closeDialog,
	confirm,
	title,
	hideTitle,
	message,
	reason,
	setReason
}) {
	return (
		<div>
			<StyledDialog
				open={open}
				onClose={closeDialog}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				{!hideTitle && (
					<DialogTitle id="alert-dialog-title">
						{title && title !== "" ? title : "Alterar o status?"}
					</DialogTitle>
				)}
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{message && message !== ""
							? message
							: "Ao clicar em confirmar você esterá alterando o status do registro."}
					</DialogContentText>
					{setReason && (
						<InputField
							onChange={setReason}
							value={reason}
							placeholder={"Me conte o motivo"}
							style={{ marginTop: 8 }}
						/>
					)}
				</DialogContent>
				<DialogActions>
					<Button
						onClick={closeDialog}
						style={{
							border: "none",
							textDecoration: "underline",
							backgroundColor: "transparent"
						}}
					>
						Cancelar
					</Button>
					<Button
						onClick={confirm}
						disabled={!reason}
						color="primary"
						autoFocus
					>
						Confirmar
					</Button>
				</DialogActions>
			</StyledDialog>
		</div>
	);
}
